export const menuItems = [
  { icon: 'mdi-cart-outline', to: '/shopping', title: 'Einkaufszettel', enabled: true },
  { icon: 'mdi-format-list-bulleted', to: '/alben', title: 'Alben', enabled: true },
  { icon: 'mdi-panorama', to: '/imageupload', title: 'Add a new stuff', enabled: true },
  { icon: 'mdi-view-dashboard', to: '/dashboard', title: 'dashboard', enabled: true },
  { icon: 'mdi-currency-eur', to: '/stocks', title: 'stocks', enabled: true },
  { icon: 'mdi-trending-up', to: '/charts', title: 'charts', enabled: true },
  { icon: 'mdi-piggy-bank-outline', to: '/portfolio', title: 'Portfolio', enabled: true },
  { icon: 'mdi-cash-multiple', to: '/einkommen', title: 'Einkommen', enabled: true },
  { icon: 'mdi-calculator-variant-outline', to: '/abfindung', title: 'Abfindungssimulation', enabled: true },
  { icon: 'mdi-bank', to: '/vermoegen', title: 'Vermögensübersicht', enabled: true },
  { icon: 'mdi-bank-check', to: '/trading', title: 'Trade-Check', enabled: true, type: 'test' },
  { icon: 'mdi-newspaper', to: '/articles', title: 'articles', enabled: true },
  { icon: 'mdi-google-analytics', to: '/analyzer', title: 'analyzer', enabled: true },
  { icon: 'mdi-chart-bar', to: '/rankings', title: 'rankings', enabled: true },
  { icon: 'mdi-cart-off', to: '/transactions', title: 'historie', enabled: true },
  { icon: 'mdi-bike', to: '/activities', title: 'activities', enabled: true },
  { icon: 'mdi-calendar-today', to: '/calendar', title: 'calendar', enabled: true },
  { icon: 'mdi-clipboard-check-outline', to: '/vacation-checklist', title: 'Urlaubs-Checkliste', enabled: true },
  { icon: 'mdi-routes', to: '/tracks2', title: 'Tracks', enabled: true },
  { icon: 'mdi-earth', to: '/trackscluster', title: 'Track Cluster', enabled: true },
  { icon: 'mdi-radar', to: '/transi', title: 'Livetrack', enabled: true },
  { icon: 'mdi-monitor', to: '/System', title: 'System', enabled: true },
  { icon: 'mdi-cog', to: '/Settings', title: 'Settings', enabled: true },
  { icon: 'mdi-robot-outline', to: '/ollama', title: 'Ollama', enabled: true},
  { icon: 'mdi-cellphone-settings', to: '/register', title: 'register', enabled: true },
  { icon: 'group', to: '/health', title: 'health', enabled: true },
  { icon: 'mdi-medical-bag', to: '/healthscorecard', title: 'Health Scorecard', enabled: true, type: 'test' },
  { icon: 'description', to: '/masterdata', title: 'MasterData', enabled: true, type: 'test' },
  { icon: 'mdi-auto-fix', to: '/TrainObjects', title: 'Train Image', enabled: true },
  { icon: 'notes', to: '/editor', title: 'editor', enabled: true, type: 'test' },
  { icon: 'info', to: '/guitest', title: 'guitest', enabled: true, type: 'test' },
]
